import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface GalleryProps {
  title: string
  titleEn?: string
  items: Array<{
    imageUrl: string
    caption?: string
    captionEn?: string
  }>
}

export default function GalleryBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as GalleryProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.items && p.items.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {(p.items || []).map((item, i) => (
            <div key={i} className="group rounded-2xl overflow-hidden bg-gray-100 aspect-square">
              <img src={item.imageUrl} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              {item.caption && (
                <div className="mt-2 text-xs text-gray-400 text-center">
                  {lang === 'en' && item.captionEn ? item.captionEn : item.caption}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
